<template>
  <div id="login">
    <b-container>
      If you forgot your login/password, it will be sent to your mailbox.
      <b-form @submit="sendMail">
        <b-form-group id="inputloginGroup" label="Enter your email" label-for="inputlogin">
          <b-form-input
            id="inputlogin"
            v-model="email"
            type="email"
            required
            @change="showLoginAlert = false"
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary">Submit</b-button>
      </b-form>

      <b-alert
        dismissible
        :show="dismissCountDown"
        :variant="variant"
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged"
        >{{ messageAlert }}</b-alert
      >
    </b-container>
  </div>
</template>

<script>
import router from '../router';

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      status: 'success',
      dismissSecs: 3,
      dismissCountDown: 0,
      messageAlert: '',
      variant: 'success',
    };
  },
  methods: {
    sendMail(evt) {
      evt.preventDefault();

      let loader = this.$loading.show({
        // Optional parameters
        container: null,
        canCancel: false,
        loader: 'dots',
      });
      this.$store.dispatch('forgotPassword', this.email).then(
        resp => {
          loader.hide();
          if (resp.body.success === true) {
            this.variant = 'success';
            this.messageAlert = resp.body.message;
            this.showAlert();
          } else {
            this.variant = 'danger';
            this.messageAlert = resp.body.message;
            this.showAlert();
          }
        },
        resp => {
          this.messageAlert = 'Server error';
          if (resp.body && resp.body.message) {
            this.messageAlert = resp.body.message;
          }
          loader.hide();
          this.variant = 'danger';
          this.showAlert();
        }
      );
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
  },
};
</script>

<style scoped>
#login {
  text-align: left;
  margin: 100px 10px 10px 10px;
}
</style>
